<template>
  <div class="invoice">
    <van-sticky>
      <div
        class="invoiceNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">发票信息</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="topCard">
        <h3>
          {{ is_company ? "企业" : "个人" }}发票信息<img
            src="./../../../assets/decoration/tip.png"
            v-if="is_company"
            alt=""
          />
        </h3>
        <img
          class="invoiceTip"
          src="./../../../assets/decoration/invoiceTip1.png"
          alt=""
          v-if="is_company"
        />
        <img
          class="invoiceTip"
          src="./../../../assets/decoration/invoiceTip2.png"
          alt=""
          v-else
        />
        <div class="textContent">
          <div class="item">
            <span>1.名称</span>
            <p>
              {{ is_company ? "浙江销巴装饰有限公司" : "浙江销巴科技有限公司" }}
            </p>
          </div>
          <div class="item">
            <span>2.税号</span>
            <p>
              {{ is_company ? "91330104MA2H15N875" : "91330104MA27YAQPXY" }}
            </p>
          </div>
          <div class="item">
            <span>3.发票内容</span>
            <p>*现代服务*服务费</p>
          </div>
        </div>
      </div>
      <div class="bomCard">
        <div class="topLeft"></div>
        <div class="topRight"></div>
        <button
          @click="copy()"
          v-if="is_company"
          id="copycode"
          data-clipboard-text="1.名称
浙江销巴装饰有限公司

2.税号
91330104MA2H15N875

3.发票内容
*现代服务*服务费"
        >
          复制信息
        </button>
        <button
          @click="copy()"
          id="copycode"
          v-else
          data-clipboard-text="1.名称
浙江销巴科技有限公司

2.税号
91330104MA27YAQPXY

3.发票内容
*现代服务*服务费"
        >
          复制信息
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      isiOSX: false,
      userData: {},
      is_company: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.is_company) {
      this.is_company = JSON.parse(this.$route.query.is_company);
    }
    console.log(this.is_company);
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    seeInvoice() {
      ImagePreview(["/src/assets/decoration/tip.png"]);
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less">
.invoice {
  min-height: 100%;
  background: #f5f6ff;
  .invoiceNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 12px 16px;
    .topCard {
      background: #ffffff;
      border-radius: 12px 12px 0 0;
      padding: 24px 16px;
      border-bottom: 2px dashed #f0f1ff;
      h3 {
        margin: 0 8px;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        display: flex;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .invoiceTip {
        width: 100%;
        transform: translateY(-37px);
      }
      .textContent {
        // border: 1px solid red;
        margin-top: -30px;
        margin-bottom: 11px;
        .item {
          display: flex;
          justify-content: space-between;
          margin-top: 16px;
          span {
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            flex-shrink: 0;
          }
          p {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            margin-left: 44px;
            text-align: right;
          }
        }
      }
    }
    .bomCard {
      padding: 24px 60px;
      background: #ffffff;
      border-radius: 0 0 12px 12px;
      position: relative;
      display: flex;
      justify-content: center;
      .topLeft {
        width: 22px;
        height: 22px;
        background: #f5f6ff;
        position: absolute;
        top: -11px;
        left: -11px;
        border-radius: 50%;
      }
      .topRight {
        width: 22px;
        height: 22px;
        background: #f5f6ff;
        position: absolute;
        top: -11px;
        right: -11px;
        border-radius: 50%;
      }
      button {
        width: 100px;
        height: 38px;
        border-radius: 25px;
        border: 1px solid #cccccc;
        line-height: 32px;
        background: #ffffff;
        font-size: 15px;
        color: #333333;
      }
    }
  }
}
</style>